export default __webpack_public_path__ + "static/media/bs-si.84c5758c.svg";